export default __webpack_public_path__ + "static/media/mobile_tc1_Cn.8baf356d.webp";